export default __webpack_public_path__ + "static/media/Thumb_Bottom_05.2ef47208.png";